export const main = {
  display: "flex",
  flexDirection: "column",
  width: "100%",
  height: "100vh",
  backgroundColor: "whitesmoke",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 13,
};
